// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/assets/';

// export const apiUrl = 'http://192.168.1.2:8000/apis/';
// export const assetsUrl = 'https://blisstainment.com/apibackend/assets/';

export const apiUrl = 'https://blisstainment.com/apibackend/apis/';
export const assetsUrl = 'https://blisstainment.com/apibackend/assets/';

// export const apiUrl = 'https://lightpink-wolf-926814.hostingersite.com/apibackend/apis/';
// export const assetsUrl = 'https://lightpink-wolf-926814.hostingersite.com/apibackend/assets/';